/* eslint-disable array-callback-return */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import OutboxSmallView from './OutboxSmallView';
import DetailBigView from './DetailBigView';
import PdfPreview from './PdfPreview';
import {
    getDocumentMetaWithDocId,
    getConfigurationData,
    GetDropdownData,
} from '../../api/api';
import {
    download,
    stringEmptyOrUndefined,
    userPermission,
    GetFieldData,
    formatNameWithSpaceTohipen,
} from '../../../components/commonfunction';
import {
    outboxPage,
    getSelectedRowDetails,
} from '../../_redux/actions/outboxActions';
import { deletedPage } from '../../_redux/actions/searchActions';
import Loader from 'react-loader-spinner';

class OutboxDetailViewComponent extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            isLockedBy: null,
            isLocked: false,
            noteCount: 0,
            pageCount: 0,
            menuBranch: null,
            menuGroup: null,
            ownerlist: [],
            processId: null,
            statusId: null,
            allStatusArray: [],
            menu_name: 'Inbox',
            branches: [],
            groups: [],
            row_transition: false,
            show_branch: false,
            branchActionId: null,
            show_group: false,
            groupActionId: null,
            show_inbox: false,
            show_delete: false,
            deleteActionId: null,
            show_tag: false,
            show_owner: false,
            show_notes: false,
            show_print: true,
            show_download: true,
            show_pdf: true,
            statusArray: [],
            notesVal: null,
            notes_ddl: null,
            notes_submitted: 0,
            open_notes: false,
            noteError: null,
            selectedRows: [],
            selectedRowData: {},
            pdf_preview: true,
            refreshView: false,
        };
    }

    componentWillUnmount = async () => {
        await this.props.outboxPage({ related_doc_detail: false });
        await document.body.classList.remove('aside-minimize');
        await document.body.classList.remove('doc-small-view');
        await document.body.classList.remove('show-detail-view');
        this._isMounted = false;
    };

    async componentDidMount() {
        this._isMounted = true;
        // if (this.props.location.state.selectedDocID === null) {

        // }
        // await this.props.outbox({
        //     stateData: { allActions: null },
        // });
        await this.setState({
            detailBigView: false,
        });
        if (this.props.loader === true && this.props.calingFrom === 'report') {
            this.props.updateState({
                loader: false,
            });
        }
        document.body.classList.add('show-detail-view');

        if (
            this.props.match.params !== undefined &&
            this.props.location.state &&
            this.props.location.state.selectedDocID
        ) {
            let docid = this.props.location.state.selectedDocID;

            docid = window.atob(String(docid));
            const { processId, statusId } = this.props.location.state;

            let rowDetails = { doc_id: docid };
            let detailsData = localStorage.getItem('detail_data');
            if (Object.keys(this.props.stateData).length > 0) {
                localStorage.setItem(
                    'detail_data',
                    JSON.stringify(this.props.stateData)
                );
                localStorage.setItem(
                    'inbox_data',
                    JSON.stringify(this.props.inbox)
                );
                rowDetails = this.props.stateData.rowDetails;
            } else if (detailsData !== null) {
                detailsData = JSON.parse(detailsData);
                rowDetails = detailsData.rowDetails;
            }
            this.setState({
                rowDetails,
                selectedDocId: docid,
            });

            const response = getDocumentMetaWithDocId({ docid });
            const configData = getConfigurationData();
            let menuBranch = null;
            let menuGroup = null;
            const fieldDataObj = GetFieldData({
                configData: this.props.configData,
            });
            await response.then(async (data) => {
                this.props.getSelectedRowDetails(data);
                const foundFields = [];
                if (data.fields !== undefined) {
                    data.fields.forEach((dataValue) => {
                        const fields = dataValue.fieldId;
                        if (fields === fieldDataObj.branchFieldId) {
                            menuBranch = dataValue.value;
                        }
                        if (fields === fieldDataObj.groupFieldId) {
                            menuGroup = dataValue.value;
                        }
                        for (const property in configData) {
                            if (configData[property].fieldId === fields) {
                                foundFields.push(configData[property]);
                            }
                        }
                    });
                }
                if (
                    data.isLocked &&
                    document.querySelector('.rdg-row.row-selected-once') !==
                        null
                ) {
                    document
                        .querySelector('.rdg-row.row-selected-once')
                        .classList.add('locked');
                }
                // changed this.props.processId to processId vise versa
                let permission = userPermission({
                    processId: processId,
                    statusId: statusId,
                    menu_name: this.props.currentMenuName,
                    configData: this.props.configData,
                });
                permission = {
                    ...permission,
                    show_pdf: true,
                    show_notes: true,
                };

                await this.setState({
                    selectedDocId: docid,
                    isLockedBy: data.isLockedBy,
                    isLocked: data.isLocked,
                    noteCount: data.noteCount,
                    pageCount: data.pageCount,
                    menuBranch,
                    menuGroup,
                    rowDetails,
                    processId,
                    statusId,
                    selectedRows: [docid],
                    ...permission,
                    selectedRowDetails: data,

                    detailBigView: true,
                });
                this.props.outboxPage({
                    processId: processId,
                    statusId: statusId,
                    selectedRowDetails: data,
                    allActions: {},
                    stateData: { allActions: {} },
                    outboxpage: {
                        stateData: { allActions: {} },
                    },
                });
                if (data !== undefined) {
                    this.setState({
                        refreshView: true,
                    });
                }
            });
        }

        const configData = getConfigurationData();
        if (configData.Branch !== undefined) {
            const branch = GetDropdownData(configData.Branch.fieldId);
            branch
                .then((response) => response.json())
                .then((data) => {
                    this.setState({
                        branchData: data,
                    });
                });
        }
        if (localStorage.getItem('branch_field_id') !== null) {
            GetDropdownData(localStorage.getItem('branch_field_id'))
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (data.values && data.values.length > 0) {
                        let newArray = [];
                        data.values.map((item) => {
                            if (
                                newArray.includes(item) !== true &&
                                item !== '' &&
                                item !== null &&
                                item !== undefined
                            ) {
                                newArray.push(item);
                            }
                        });
                        this.setState({ branches: newArray });
                    }
                })
                .catch((error) => {});
        }
        if (localStorage.getItem('group_field_id') !== null) {
            GetDropdownData(localStorage.getItem('group_field_id'))
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (data.values && data.values.length > 0) {
                        let newArray = [];
                        data.values.map((item) => {
                            if (
                                newArray.includes(item) !== true &&
                                item !== '' &&
                                item !== null &&
                                item !== undefined
                            ) {
                                newArray.push(item);
                            }
                        });
                        this.setState({ groups: newArray });
                    }
                })
                .catch((error) => {});
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.state) {
            const { scrollView } = this.props.location.state;
            if (scrollView !== undefined && scrollView === true) {
                window.scrollTo(0, document.body.scrollHeight);
            }
        }

        if (this.props.loader === true && this.props.calingFrom === 'report') {
            this.props.updateState({
                loader: false,
            });
        }
        // setTimeout(() => {
        //     this.setState({ refreshView: true });
        // }, 100);
    }

    rowTransition = async () => {
        await this.setState({ row_transition: false });
        localStorage.setItem('disable_checkbox', false);
    };

    set_group = (event) => {
        this.setState({ menu_group: event.target.value });
    };

    goToPage = () => {
        const currentPath = window.location.pathname.split('/');
        const lastIndex = window.location.pathname.lastIndexOf('/');
        const before = window.location.pathname.slice(0, lastIndex);
        const reportIndex = before.lastIndexOf('/');
        const ReportName = before.slice(reportIndex + 1);

        if (this.props.calingFrom === 'report') {
            this.props.updateState({
                hideSmallView: false,
                // visibleDoc: false,
            });

            // this.props.history.goBack();

            let pushPath;
            this.props.configData.reports.map((data) => {
                if (ReportName === formatNameWithSpaceTohipen(data.name)) {
                    pushPath = before + '/' + data.reportId;
                }
            });
            this.props.history.push(pushPath);

            document.body.classList.remove('aside-minimize');
            document.body.classList.remove('doc-small-view');
            this.props.deletedPage({
                hideSmallView: false,
            });
            // this.props.removeAllGrouping();
        } else if (currentPath[1] === 'search') {
            this.props.history.goBack();
            this.props.deletedPage({
                onlySearch_outbox: false,
            });
        } else {
            this.props.outboxPage({ related_doc_detail: false });
            this.props.history.goBack();
            setTimeout(() => {
                if (this.props.related_doc_from !== 'bigview') {
                    document.body.classList.add('aside-minimize');
                    document.body.classList.add('doc-small-view');
                }

                if (this.props.related_doc_from === 'bigview') {
                    document.body.classList.add('aside-minimize');
                    this.props.outboxPage({ related_doc_from: '' });
                }
            }, 1000);
        }
    };

    render() {
        return (
            <>
                <div
                    id='right-aside'
                    className='right-aside py-5 rounded-lg  aside-fixed flex-row-auto aside-small-view'
                    // id='left-aside'
                    // className={
                    //         'left-aside py-5 rounded-lg  aside-fixed flex-row-auto aside-small-view'}
                >
                    {this.props.calingFrom !== 'report' && (
                        <OutboxSmallView
                            selectedDocId={
                                this.props.location.state &&
                                this.props.location.state.selectedDocID
                                    ? window.atob(
                                          this.props.location.state
                                              .selectedDocID
                                      )
                                    : undefined
                            }
                            isLocked={this.state.isLocked}
                            lockedBy={this.state.isLockedBy}
                            noteCount={this.state.noteCount}
                            pageCount={this.state.pageCount}
                            detailView
                            ownerlist={this.state.ownerlist}
                            rowDetails={this.state.rowDetails}
                            notesDDL={JSON.parse(
                                localStorage.getItem('noteTypes')
                            )}
                            menuGroup={this.state.menuGroup}
                            goToPage={this.goToPage}
                            // pdf_preview
                            pdf_preview={this.state.pdf_preview}
                            callingFrom='related_document'
                            reportView={this.props.calingFrom}
                            updateState={(state) => {
                                this.setState({ ...state });
                                this.props.updateState(state);
                            }}
                        />
                    )}
                    {this.state.pdf_preview ? (
                        <PdfPreview
                            docId={
                                this.props.location.state &&
                                this.props.location.state.selectedDocID
                                    ? window.atob(
                                          this.props.location.state
                                              .selectedDocID
                                      )
                                    : undefined
                            }
                            // docId={this.state.selectedDocId}
                            detailBigView={this.state.detailBigView}
                            isLocked={this.state.is_locked}
                            reportView={this.props.calingFrom}
                        />
                    ) : null}
                </div>
                <div
                    id='left-aside'
                    className='expand-mode left-aside py-9 rounded-lg aside-fixed flex-row-auto'
                >
                    {this.props.outbox.selectedRowDetails.fields !==
                        undefined && this.state.detailBigView ? (
                        <DetailBigView
                            selectedDocId={
                                this.props.location.state &&
                                this.props.location.state.selectedDocID
                                    ? window.atob(
                                          this.props.location.state
                                              .selectedDocID
                                      )
                                    : undefined
                            }
                            download={() => {
                                download(
                                    this.props.location.state.selectedDocID !==
                                        undefined
                                        ? window.atob(
                                              this.props.location.state
                                                  .selectedDocID
                                          )
                                        : undefined,
                                    this.state.rowDetails
                                );
                            }}
                            openDeletePopUp={() => {}}
                            statusArray={this.state.statusArray}
                            branches={this.state.branches}
                            groups={this.state.groups}
                            rowTransition={() => {
                                this.rowTransition();
                            }}
                            menuGroup={this.state.menuGroup}
                            showBranch={this.state.show_branch}
                            showDelete={this.state.show_delete}
                            showDownload={this.state.show_download}
                            showGroup={this.state.show_group}
                            showInbox={this.state.show_inbox}
                            showNotes={this.state.show_notes}
                            showOwner={this.state.show_owner}
                            showPrint={this.state.show_print}
                            showPdf={this.state.show_pdf}
                            detailView
                            menuBranch={this.state.menuBranch}
                            menuInbox={this.state.menu_inbox}
                            goToPage={this.goToPage}
                            callingFrom='related_document'
                            reportView={this.props.calingFrom}
                            updateState={(state) => {
                                this.setState({ ...state });
                                this.props.updateState(state);
                            }}
                            selectedRowDetails={this.state.selectedRowDetails}
                            ReportprocessId={this.state.processId}
                            ReportstatusId={this.state.statusId}
                            propsCalingFrom={this.props.calingFrom}
                        />
                    ) : (
                        <div
                            style={{ textAlign: 'center' }}
                            className='pdf_loader'
                        >
                            <Loader
                                type='Oval'
                                color='#007dbc'
                                height={40}
                                width={40}
                                // timeout={5000}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    }
}

const mapDispatchToProps = {
    outboxPage,
    getSelectedRowDetails,
    deletedPage,
}; // added , getSelectedRowDetails in order to fix RD detail page same as parent doc

const mapStateToProps = (state) => {
    return {
        rowData: state.inbox,

        outbox: state.outbox,
        configData: stringEmptyOrUndefined(state.configReducerPersist)
            ? state.configReducerPersist.configData
            : {},
        currentMenuName: state.persist.currentMenuName,
        processId: state.inbox.processId,
        statusId: state.inbox.statusId,
        stateData: stringEmptyOrUndefined(state.inbox)
            ? state.inbox.stateData
            : {},
        inbox: stringEmptyOrUndefined(state.inbox) ? state.inbox : {},
        related_doc_from: state.outbox.outboxpage.related_doc_from,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(OutboxDetailViewComponent));
